import React from 'react';
import { RouteProps } from 'react-router-dom';

import PrivateRoute from './PrivateRoute';

import { getUserData } from '../../../services/localSorage';

const PrivateRouteContainer: React.FC<RouteProps> = (props: RouteProps) => {
  const { user, token } = getUserData();

  return <PrivateRoute authenticated={Boolean(user?.id && token)} {...props} />;
};

export default PrivateRouteContainer;
